import { Card, Typography } from 'antd';
const { Text } = Typography;


export interface CustomTooltipProps {
    active?: boolean;
    payload?: any[];
    label?: string;
}

const CustomTooltip = ({ active, payload, label }: CustomTooltipProps) => {
    if (active && payload && payload.length) {
        return (
            <Card size="small" style={{ border: 'none', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                <Text strong>{label}</Text>
                <div style={{ marginTop: '8px' }}>
                    {payload.map((entry, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                            <div style={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: entry.color
                            }} />
                            <Text>{entry.name}: {entry.value.toLocaleString()}</Text>
                        </div>
                    ))}
                </div>
            </Card>
        );
    }
    return null;
}

export default CustomTooltip